import React from "react";
import { Row, Card, Button } from "react-bootstrap";
// helper
import { infoCardComponent } from "../../helper/card";
// icons
import { IoMdOpen } from "react-icons/io";

const cardStyle = { width: "390px" };

const InfoTabClinician = () => {
  return (
    <Row className="d-flex flex-wrap">
      {infoCardComponent({
        title: "Materialien zur Nutzung von SysDok",
        content: (
          <>
            <Card.Text>
              Im internen Bereich unserer Website befinden sich alle wichtigen
              Informationen für die Anwendung von SysDok. Hier finden Sie unsere
              Schulungsvideos, unser SysDok-Handbuch sowie weitere Materialien
              wie den Monitoring-Helper und die Übungsblätter. Einloggen können
              Sie sich mit:
              <br />
              <br />
              <b>Benutzername: </b>Systemisch
              <br />
              <b>Passwort: </b>HalloSysDok!
              <br />
            </Card.Text>

            <a
              href=" https://sysdok.de/accounts/login/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button variant="primary">
                <IoMdOpen /> Interner Bereich
              </Button>
            </a>
          </>
        ),
        style: cardStyle,
      })}
      {infoCardComponent({
        title: "FAQs",
        content: (
          <>
            <Card.Text>
              Hier finden Sie Antworten auf häufige Fragen von Therapeut:innen.
            </Card.Text>

            <a
              href="https://sysdok.de/de/fuer-therapeutinnen/#FAQ"
              target="blank"
            >
              <Button variant="primary">
                <IoMdOpen /> FAQ
              </Button>
            </a>
          </>
        ),
        style: cardStyle,
      })}
    </Row>
  );
};

export default InfoTabClinician;
